import { css } from 'lit';

export const styles = css`

  :host {
    display: block;
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }

  ::slotted(nile-checkbox) {
    display: block;
    margin-bottom: var(--nile-spacing-md, var(--ng-spacing-md));
  }

  ::slotted(nile-checkbox:last-of-type) {
    margin-bottom: 0;
  }

  .form-control--inline-checkbox ::slotted(nile-checkbox) {
    display: inline-block;
    margin-bottom: 0;
    margin-right: var(--nile-spacing-3xl, var(--ng-spacing-3xl));
  }

  .form-control {
    border: none;
    padding: var(--nile-spacing-none, var(--ng-spacing-none));
    margin: var(--nile-spacing-none, var(--ng-spacing-none));
  }

  .form-control__label {
    display: block;
    padding: var(--nile-spacing-none, var(--ng-spacing-none));
    margin-bottom: var(--nile-spacing-md, var(--ng-spacing-md));
    font-size: var(--nile-type-scale-3, var(--ng-font-size-text-sm));
    color: var(--nile-colors-dark-900, var(--ng-colors-text-primary-900));
    font-family: var(--nile-font-family-serif, var(--ng-font-family-body));
    font-style: normal;
    font-weight: var(--nile-font-weight-regular, var(--ng-font-weight-regular));
    line-height: var(--nile-line-height-xsmall, var(--ng-line-height-text-xs));
    letter-spacing: 0.2px;
  }

  .form-control-input {
    margin-bottom: var(--nile-spacing-md, var(--ng-spacing-md));
  }

  .checkbox-group--required .checkbox-group__label::after {
    content: '*';
    margin-inline-start: -2px;
  }

  .form-control--bordered {
    border: 1px solid var(--nile-colors-neutral-400, var(--ng-colors-border-secondary));
    border-radius: var(--nile-radius-radius-sm, var(--ng-radius-sm));
    padding: var(--nile-spacing-lg, var(--ng-spacing-lg));
    margin: var(--nile-spacing-none, var(--ng-spacing-none));
  }

  .form-control__legend {
    padding: var(--nile-spacing-none, var(--ng-spacing-none)) var(--nile-spacing-xs, var(--ng-spacing-xs));
    font-size: var(--nile-type-scale-3, var(--ng-font-size-text-sm));
    color: var(--nile-colors-dark-900, var(--ng-colors-text-primary-900));
    font-family: var(--nile-font-family-serif, var(--ng-font-family-body));
    font-weight: var(--nile-font-weight-medium, var(--ng-font-weight-medium));
    line-height: var(--nile-line-height-xsmall, var(--ng-line-height-text-xs));
  }
`;
